/** Имя таблицы списка диалогов — ключ её настроек и пресетов в настройках пользователя */
export const DIALOGS_TABLE_NAME = 'dialogsListV2';

export const MAIN_COLUMNS = {
  id: 'id',
  externalId: 'externalId',
  createdAt: 'createdAt',
  client: 'client',
  employeeId: 'employeeId',
  hasTranscription: 'hasTranscription',
} as const;

export type MainColumnKey = keyof typeof MAIN_COLUMNS;

export const MAIN_COLUMN_KEYS = Object.keys(MAIN_COLUMNS) as MainColumnKey[];

// id, externalId и hasTranscription скрыты по умолчанию, остальные колонки видимы
export const DEFAULT_MAIN_COLUMNS = ['createdAt', 'client', 'employeeId'];
